import Header from "../components/Header";
import { useTranslation } from "react-i18next";

const QuyTacGiamGia = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  return (
    <div className="wrapper">
      <div className="container-web quytacgiamgia bgnew">
        <Header title={t("Quy tắc giảm giá")} />
        <main>
          <div className="p-3">
            <h6 style={{ fontSize: 14, color: "#eecb77" }}>
              {t("Điều kiện hoàn tiền")}
            </h6>
            <p style={{ fontSize: 13, color: "#fff" }}>
              ● {t("Sự kết hợp (nhiều đơn ,nhiều đôi ,đơn trống ,đôi trống ) ≥1% tổng vốn đầu tư")}
            </p>

            <div style={{ fontSize: 13, color: "#fff", background: "#404040" }}>
              <div
                className="d-flex justify-content-between px-3 py-2 border-bottom"
                style={{ color: "#eecb [77", background: "#323131" }}
              >
                <span>{t("Đầu tư (trong ngày)")}</span>
                <span>{t("Số tiền hoàn lại")}</span>
              </div>

              <div className="d-flex justify-content-between px-3 py-2">
                <span>{t("1 ≤ 1 ≤Tổng thiệt hại  < 2  < 2")}</span>
                <span>{t("0 VND")}</span>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default QuyTacGiamGia;
